module.exports = __webpack_public_path__ + "static/media/icon-arrow-long.d8ecbf9f.svg";